// extracted by mini-css-extract-plugin
module.exports = {"mIconList":"IconTitleList_mIconList__5sA7K","mListItem":"IconTitleList_mListItem__Df75L","mImage":"IconTitleList_mImage__ZeqTF","aTitle":"IconTitleList_aTitle__sVcJ9"};